// extracted by mini-css-extract-plugin
export default {"modalLogout":"ModalLogOut_modalLogout__Y6peQ","modalTitle":"ModalLogOut_modalTitle__MKTvK","logoutBtn":"ModalLogOut_logoutBtn__B81UD","cancelBtn":"ModalLogOut_cancelBtn__+QKFn"};